// axios
import axios from 'axios'
import store from './store/store'
import router from './router'

const baseURL = process.env.VUE_APP_API_HOST;

let axiosInstance = axios.create({
	baseURL,
	headers: {
		Authorization: "Bearer "+ store.state.auth.token,
		'Content-Type': 'application/json'
	},
});

axiosInstance.interceptors.request.use(function(config) {
	// if(config.method === 'GET' || config.method === 'get') {
	let param = `language=${store.state.locale}`;

	if(config.url.indexOf('?') === -1) {
		config.url += '?' + param;
	} else {
		config.url += '&' + param;
	}
	// }

	return config;
})

axiosInstance.interceptors.response.use((response) => response, (error) => {
	if (error.response.status === 401) {
		localStorage.removeItem('token')
		localStorage.removeItem('layout')
		localStorage.removeItem('role')
		store.dispatch('logout')
		router.push('/login')
	}
	throw error;
});

export default axiosInstance;

